import axios from 'axios'
import jsonpAdapter from 'axios-jsonp'

const url = 'https://get.geojs.io/v1/ip/geo.js'

export const getCountry = async () => {
  const { data } = await axios({
    url,
    adapter: jsonpAdapter
  })

  return data.country
}
